import React, { FunctionComponent } from 'react';
import { Alert, Box, Button, Grid, Typography } from '@mui/material';
import { ColDef } from 'ag-grid-community';

import Table from '../shared/Table';
import CenteredSpinner from '../shared/CenteredSpinner';

import type { ScenarioTag } from './ManageScenarioTags';

interface ITagsTableContentProps {
  tags: ScenarioTag[];
  isDataLoading: boolean;
  onRefresh: () => void;
  onAddTag: () => void;
  columnDefs: ColDef[];
  tableId?: string;
  infoText?: string;
}

const TagsTableContent: FunctionComponent<ITagsTableContentProps> = ({
  tags,
  isDataLoading,
  onRefresh,
  onAddTag,
  columnDefs,
  tableId = 'scenario-tags-table',
  infoText = 'AI Scenario Tags are used by the AI reporting interface to isolate a set of model scenarios for inclusion when performing AI tasks such as report generation and input scenario adjustments.',
}) => {
  return (
    <>
      <Alert severity="info" sx={{ mb: 3 }}>
        {infoText}
      </Alert>

      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Grid item md={9}></Grid>
        <Grid item md={3} container justifyContent="flex-end" spacing={1}>
          <Grid item>
            <Button
              onClick={onRefresh}
              variant="outlined"
              size="small"
              disabled={isDataLoading}
            >
              Refresh
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={onAddTag}
              variant="contained"
              size="small"
              disabled={isDataLoading}
            >
              Add Tag
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {isDataLoading ? (
        <CenteredSpinner />
      ) : tags && tags.length > 0 ? (
        <Table
          id={tableId}
          isLoading={false}
          isSuccess
          pagination={tags.length > 0}
          rowCount={tags.length}
          rowData={tags}
          columnDefs={columnDefs}
          defaultColDef={{
            suppressAutoSize: true,
            suppressMenu: true,
            suppressSizeToFit: true,
          }}
        />
      ) : (
        <Box textAlign="center" py={4}>
          <Typography variant="body1" color="text.secondary">
            No scenario tags found. Click "Add Tag" to create one.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default TagsTableContent;
